import React, { Suspense, lazy } from 'react';
import { NavBar } from "@/components/NavBar";
import { TutorialDemoMode } from '@/components/tutorial/TutorialDemoMode';
import { Helmet } from 'react-helmet';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';

const Footer = lazy(() => import("@/components/Footer"));

const TutorialPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col bg-stone-50 dark:bg-stone-950">
      <Helmet>
        <title>IELTS Writing Practice | Tutorial</title>
        <meta name="description" content="Practice IELTS Writing Task 2 with AI feedback" />
      </Helmet>

      <NavBar />

      <main className="flex-grow px-4 py-8 container mx-auto max-w-6xl">
        <div className="mb-6 flex items-center">
          <Button
            variant="ghost"
            onClick={() => navigate('/dashboard')}
            className="h-9 px-2"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Dashboard
          </Button>
          <h1 className="text-2xl font-bold dark:text-white ml-4">IELTS Writing Practice</h1>
        </div>

        <div className="dashboard-container mb-8">
          <Card className="border-stone-200 dark:border-stone-700 mb-6 bg-amber-50 dark:bg-stone-800/50">
            <CardContent className="pt-6">
              <p className="text-stone-700 dark:text-stone-300">
                <span className="font-semibold">Tutorial Mode:</span> This guided tutorial will help you learn how to use IELTS With AI. You can interact with highlighted elements to experience the platform's features. Follow the instructions in the tooltip to continue.
              </p>
            </CardContent>
          </Card>

          {/* TutorialDemoMode component contains the actual practice interface */}
          <TutorialDemoMode />
          
          {/* The progress chart is only shown in the dashboard and will be highlighted in step 9 */}
          <div className="progress-chart mt-12 hidden">
            {/* This element exists only to be targeted by the tutorial in step 9, but we'll navigate to dashboard for it */}
          </div>
        </div>
      </main>

      <Suspense fallback={<div className="h-16" />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default TutorialPage;
